import { ComponentRef, Directive, inject, OnChanges, OnDestroy, Type, ViewContainerRef, input } from '@angular/core';

// /**
//  * 动态创建组件
//  * @param {Compiler} compiler
//  * @param {Component} metadata
//  * @return {Promise<ComponentFactory<any>>}
//  * @since 1.0
//  * @version 1.0
//  */
// export function createComponentFactory(compiler: Compiler, metadata: Component): Promise<ComponentFactory<any>> {
//   const cmpClass = class DynamicComponent {
//   };
//   const decoratedCmp = Component(metadata)(cmpClass);
//
//   @NgModule({imports: [CommonModule, RouterModule, InputCommonModule], declarations: [decoratedCmp]})
//   class DynamicHtmlModule {
//   }
//
//   return compiler.compileModuleAndAllComponentsAsync(DynamicHtmlModule)
//     .then((moduleWithComponentFactory: ModuleWithComponentFactories<any>) => {
//       return moduleWithComponentFactory.componentFactories.find(x => x.componentType === decoratedCmp);
//     });
// }

/**
 * 分站首页组件
 * 显示分站的个性化首页
 * @since 1.0
 * @version 1.0
 */
@Directive({
  selector: 'site-home',
  standalone: false,
})
export class SiteHomeDirective implements OnChanges, OnDestroy {
  readonly html = input<string>(undefined);
  cmpRef: ComponentRef<any>;
  readonly viewContainerRef = inject(ViewContainerRef);

  ngOnChanges() {
    const htmlValue = this.html();
    if (!htmlValue) {
      return;
    }

    if (this.cmpRef) {
      this.cmpRef.destroy();
    }

    // const compMetadata = new Component({
    //   selector: 'dynamic-html',
    //   template: this.html,
    // });
    //
    // createComponentFactory(this.compiler, compMetadata)
    //   .then(factory => {
    //     const injector = ReflectiveInjector.fromResolvedProviders([], this.vcRef.parentInjector);
    //     this.cmpRef = this.vcRef.createComponent(factory, 0, injector, []);
    //   });
    const html = document.createElement('html');
    html.innerHTML = htmlValue;
    const jss = html.getElementsByTagName('script');

    // 动态加载js
    if (jss.length > 0) {
      this.loadJsSynced(jss, 0);
    }

    html.remove();
  }

  /**
   * 同步加载 js
   * @param jss
   * @param index
   * @return {any}
   */
  loadJsSynced(jss, index) {
    const js = jss[index];
    if (index === jss.length - 1) {
      return this.loadJS(js.src, undefined);
    } else {
      return this.loadJS(js.src, () => {
        this.loadJsSynced(jss, index + 1);
      });
    }
  }

  loadJS(url, success) {
    const domScript: any = document.createElement('script');
    domScript.src = url;
    success = success || function () {};
    domScript.onload = () => {
      if (!domScript.readyState || domScript.readyState === 'loaded' || domScript.readyState === 'complete') {
        console.log('succeed:' + url);
        success();
        domScript.onload = null;
        // domScript.parentNode.removeChild(domScript);
      }
    };
    console.log('load:' + url);
    document.getElementsByTagName('head')[0].appendChild(domScript);
  }

  ngOnDestroy() {
    if (this.cmpRef) {
      this.cmpRef.destroy();
    }
  }
}

export class CodeSnippt {
  constructor(
    public component: Type<any>,
    public data: any
  ) {}
}
